import { QuestResponseQuestType } from '@kidshome/api-contract';

/**
 * Presentational glyph per quest type (ADR-0032 §7 — `questType` is metadata only: it drives the
 * builder's quick-start templates and the card's icon/grouping, nothing in the domain). Shared by the
 * builder type chips, the admin table, and the family quest card so a quest's face is consistent
 * everywhere. A completed quest still overrides this with the celebration glyph at its call site.
 */
export const QUEST_TYPE_EMOJI: Record<QuestResponseQuestType, string> = {
  [QuestResponseQuestType.daily]: '☀️',
  [QuestResponseQuestType.weekly]: '📅',
  [QuestResponseQuestType.epic]: '⚔️',
  [QuestResponseQuestType.story]: '📖',
  [QuestResponseQuestType.seasonal]: '🍂',
  [QuestResponseQuestType.custom]: '✨',
};

/** The quest types in the order the builder chips + groupings present them. */
export const QUEST_TYPES = [
  QuestResponseQuestType.daily,
  QuestResponseQuestType.weekly,
  QuestResponseQuestType.epic,
  QuestResponseQuestType.story,
  QuestResponseQuestType.seasonal,
  QuestResponseQuestType.custom,
] as const;

/** The card glyph for a quest of the given type (falls back to the custom glyph for safety). */
export function questTypeGlyph(type: QuestResponseQuestType): string {
  return QUEST_TYPE_EMOJI[type] ?? QUEST_TYPE_EMOJI[QuestResponseQuestType.custom];
}
